import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getMemberRedeemableePoints = createSelector(membersState, (members: OLO.State.Members) => members.redeemablePoints?.data || null);
